import { i18n } from '@/shared/i18n';
import type { TaxonomyListChangeLogEntry } from '@/entities/taxonomy-list';

/** Renders the structured context the backend attached to an entry. */
export function describeMetadata(entry: TaxonomyListChangeLogEntry): string | null {
  const meta = entry.metadata;
  if (!meta) return null;
  const bits: string[] = [];
  if (typeof meta.versionNumber === 'number')
    bits.push(i18n.t('knowledge:taxonomy.common.versionLabel', { number: meta.versionNumber }));
  if (typeof meta.renumberedFrom === 'number')
    bits.push(
      i18n.t('knowledge:taxonomy.listHistoryDrawer.renumberedFrom', {
        version: meta.renumberedFrom,
      }),
    );
  if (typeof meta.rowCount === 'number')
    bits.push(i18n.t('knowledge:taxonomy.listHistoryDrawer.optionCount', { count: meta.rowCount }));
  if (typeof meta.columnCount === 'number')
    bits.push(
      i18n.t('knowledge:taxonomy.listHistoryDrawer.columnCount', { count: meta.columnCount }),
    );
  if (typeof meta.seededFrom === 'string')
    bits.push(i18n.t('knowledge:taxonomy.listHistoryDrawer.monksflowStandard'));
  if (typeof meta.restoredFromVersionNumber === 'number') {
    bits.push(
      i18n.t('knowledge:taxonomy.listHistoryDrawer.restoredFromVersion', {
        version: meta.restoredFromVersionNumber,
      }),
    );
  }
  return bits.length > 0 ? bits.join(' · ') : null;
}
